import { render, staticRenderFns } from "./StaticFooter.vue?vue&type=template&id=dfb2bf40&scoped=true&"
import script from "./StaticFooter.vue?vue&type=script&lang=js&"
export * from "./StaticFooter.vue?vue&type=script&lang=js&"
import style0 from "./StaticFooter.vue?vue&type=style&index=0&id=dfb2bf40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb2bf40",
  null
  
)

export default component.exports